import { Injectable } from '@angular/core';
import { GridDataService } from '../base-data-services/grid-data.service';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import {  GridPostParams } from 'common/models/utility-models/list-utility.model';
import { studentFeedbackListingModel } from 'common/models/page-models/student-feedback/student-feedback-grid-model';
import { studentFeedbackModel } from 'common/models/page-models/student-feedback/student-feedback-model';

@Injectable({
    providedIn: 'root'
})
export class studentFeedbackGridDataService extends GridDataService<studentFeedbackListingModel, studentFeedbackModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.studentFeedbackGrid, http, ss);

      
        
    }

    createInstance(): studentFeedbackListingModel {
        return new studentFeedbackListingModel();
    }

    override getGridParams(param): GridPostParams {
        return '';
    }

    override getDeleteUrl(): string {
        return "";
    }
    override getDataParam(): string {
        return 'details';
    }

}
